<template>
  <div class="save-time" v-show="time.length > 0">{{time}}保存成功</div>
</template>

<script>
export default {
  name: 'SavedTime',
  props: {
    time: String,
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/mixin.less";

.save-time {
  position: fixed;
  right: 66px;
  top: 60px;
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  &::before {
    content: '';
    width: 20px;
    height: 20px;
    display: block;
    .bg-img('~@/assets/images/autoSaved');
    background-size: 100% 100%;
    position: absolute;
    left: -24px;
  }
  &.save_green::before {
    .bg-img('~@/assets/images/autoSaved__green')
  }
}
</style>
